<app-basic-select [options]="transmissions" [(ngModel)]="localValue" [iconClass]="'toggles fw-semibold'" [title]="title" (ngModelChange)="onValueChange($event)"></app-basic-select>
